// A2 - Ünite 2: Past Simple - Olumsuz ve Soru
// Hedef: Didn't, Did you...?, WH sorular geçmiş zaman

export const A2_UNIT_2 = {
  'A2-U2-L1': {
    id: 'A2-U2-L1',
    title: "Wasn't / Weren't (To Be Olumsuz)",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Was/Were Olumsuz',
          explanation: 'Was ve were\'ın olumsuz formu: was not (wasn\'t) ve were not (weren\'t)',
          table: {
            headers: ['Özne', 'Olumsuz', 'Örnek', 'Türkçesi'],
            rows: [
              ['I', "wasn't", "I wasn't late.", 'Geç kalmadım.'],
              ['You', "weren't", "You weren't there.", 'Orada değildin.'],
              ['He/She/It', "wasn't", "She wasn't tired.", 'Yorgun değildi.'],
              ['We', "weren't", "We weren't busy.", 'Meşgul değildik.'],
              ['They', "weren't", "They weren't on the flight.", 'Uçuşta değildiler.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Olumsuz', 'Türkçesi'],
            rows: [
              ["The flight wasn't delayed.", 'Uçuş rötar yapmadı.'],
              ["The passengers weren't worried.", 'Yolcular endişeli değildi.'],
              ["I wasn't at that gate.", 'O kapıda değildim.'],
              ["There wasn't any turbulence.", 'Hiç türbülans yoktu.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 I/He/She/It = wasn\'t | You/We/They = weren\'t'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: "The flight _____ delayed yesterday.",
          options: ["wasn't", "weren't", "didn't", "isn't"],
          correct: "wasn't",
          explanation: "The flight (tekil) ile wasn't"
        },
        {
          type: 'fillInBlank',
          sentence: "The passengers _____ happy with the delay.",
          answer: "weren't",
          hint: "Passengers (çoğul) ile weren't"
        },
        {
          type: 'matching',
          instruction: 'Olumlu ve olumsuz formları eşleştirin',
          pairs: [
            { left: 'I was', right: "I wasn't" },
            { left: 'They were', right: "They weren't" },
            { left: 'She was', right: "She wasn't" }
          ]
        }
      ]
    }
  },
  'A2-U2-L2': {
    id: 'A2-U2-L2',
    title: "Didn't + fiil (Olumsuz)",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Past Simple Olumsuz',
          explanation: 'Geçmiş zamanda olumsuz cümle yapmak için "did not" (didn\'t) + fiil kök hali kullanılır. Fiil değişmez!',
          table: {
            headers: ['Özne', 'Yardımcı', 'Fiil', 'Örnek'],
            rows: [
              ['I', "didn't", 'work', "I didn't work yesterday."],
              ['You', "didn't", 'fly', "You didn't fly last week."],
              ['He/She', "didn't", 'check', "She didn't check the cabin."],
              ['We', "didn't", 'serve', "We didn't serve dinner."],
              ['They', "didn't", 'arrive', "They didn't arrive on time."]
            ]
          }
        },
        {
          type: 'grammar',
          title: '⚠️ Önemli Kural',
          explanation: 'Olumsuz cümlede fiil HER ZAMAN kök haliyle kalır. -ed veya düzensiz form KULLANILMAZ!',
          table: {
            headers: ['Yanlış ❌', 'Doğru ✓'],
            rows: [
              ["I didn't worked", "I didn't work"],
              ["She didn't flew", "She didn't fly"],
              ["We didn't went", "We didn't go"]
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Olumlu: She worked ✓ | Olumsuz: She didn\'t work ✓ (worked DEĞİL!)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: "I _____ to the briefing yesterday.",
          options: ["didn't go", "didn't went", "not go", "don't go"],
          correct: "didn't go",
          explanation: "didn't + fiil kök hali (go)"
        },
        {
          type: 'multipleChoice',
          question: "She _____ the safety demonstration.",
          options: ["didn't watch", "didn't watched", "not watched", "doesn't watch"],
          correct: "didn't watch",
          explanation: "didn't + fiil kök hali"
        },
        {
          type: 'fillInBlank',
          sentence: "We _____ (not/serve) alcohol on that flight.",
          answer: "didn't serve",
          hint: "didn't + serve"
        },
        {
          type: 'fillInBlank',
          sentence: "The plane _____ (not/land) on time.",
          answer: "didn't land",
          hint: "didn't + land (kök hali)"
        }
      ]
    }
  },
  'A2-U2-L3': {
    id: 'A2-U2-L3',
    title: 'Did you...? (Soru)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Past Simple Soru',
          explanation: 'Geçmiş zamanda soru yapmak için "Did" cümlenin başına gelir. Fiil kök haliyle kalır.',
          table: {
            headers: ['Yardımcı', 'Özne', 'Fiil', 'Örnek'],
            rows: [
              ['Did', 'you', 'work?', 'Did you work yesterday?'],
              ['Did', 'she', 'fly?', 'Did she fly last week?'],
              ['Did', 'they', 'arrive?', 'Did they arrive on time?']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📝 Soru ve Cevap',
          table: {
            headers: ['Soru', 'Kısa Cevap (Evet)', 'Kısa Cevap (Hayır)'],
            rows: [
              ['Did you work yesterday?', 'Yes, I did.', "No, I didn't."],
              ['Did she fly to Paris?', 'Yes, she did.', "No, she didn't."],
              ['Did they check the cabin?', 'Yes, they did.', "No, they didn't."]
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Was/Were ile soru: Was she tired? | Diğer fiillerle soru: Did she work?'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ you work yesterday?',
          options: ['Did', 'Do', 'Does', 'Were'],
          correct: 'Did',
          explanation: 'Geçmiş zaman sorusu: Did + özne + fiil'
        },
        {
          type: 'multipleChoice',
          question: '_____ she fly to Istanbul last week?',
          options: ['Did', 'Does', 'Do', 'Was'],
          correct: 'Did',
          explanation: 'Fiil sorusu için Did kullanılır'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ they arrive on time? - Yes, they _____.',
          answer: 'Did, did',
          hint: 'Soru ve kısa cevap'
        },
        {
          type: 'matching',
          instruction: 'Soruları cevaplarla eşleştirin',
          pairs: [
            { left: 'Did you work?', right: 'Yes, I did.' },
            { left: 'Did she fly?', right: "No, she didn't." },
            { left: 'Was he tired?', right: 'Yes, he was.' }
          ]
        }
      ]
    }
  },
  'A2-U2-L4': {
    id: 'A2-U2-L4',
    title: 'WH Sorular (Geçmiş Zaman)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 WH + Did Sorular',
          explanation: 'WH soru kelimeleri ile geçmiş zaman sorusu: WH + did + özne + fiil?',
          table: {
            headers: ['WH', 'Soru', 'Türkçesi'],
            rows: [
              ['What', 'What did you do?', 'Ne yaptın?'],
              ['Where', 'Where did she go?', 'Nereye gitti?'],
              ['When', 'When did they arrive?', 'Ne zaman vardılar?'],
              ['Why', 'Why did he leave?', 'Neden ayrıldı?'],
              ['How', 'How did it happen?', 'Nasıl oldu?'],
              ['Who', 'Who did you see?', 'Kimi gördün?']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Mülakat Geçmiş Zaman Soruları',
          table: {
            headers: ['Soru', 'Türkçesi'],
            rows: [
              ['What did you do in your previous job?', 'Önceki işinizde ne yaptınız?'],
              ['Where did you study?', 'Nerede okudunuz?'],
              ['Why did you leave your last job?', 'Son işinizden neden ayrıldınız?'],
              ['How did you handle that situation?', 'O durumu nasıl idare ettiniz?']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "Who" özne olunca did KULLANILMAZ: Who saw you? (Kim seni gördü?)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ did you do yesterday?',
          options: ['What', 'When', 'Where', 'Why'],
          correct: 'What',
          explanation: 'What = Ne'
        },
        {
          type: 'multipleChoice',
          question: '_____ did the flight leave?',
          options: ['When', 'What', 'Who', 'Which'],
          correct: 'When',
          explanation: 'When = Ne zaman'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ did you work before? - At a hotel.',
          answer: 'Where',
          hint: 'Cevap yer bildiriyor'
        },
        {
          type: 'matching',
          instruction: 'Soruları cevaplarla eşleştirin',
          pairs: [
            { left: 'What did you do?', right: 'I worked at a hotel.' },
            { left: 'When did you start?', right: 'In 2020.' },
            { left: 'Why did you leave?', right: 'For a new opportunity.' }
          ]
        }
      ]
    }
  },
  'A2-U2-L5': {
    id: 'A2-U2-L5',
    title: 'Uygulama: Mülakat Deneyim Soruları',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Mülakat Diyaloğu',
          explanation: 'Geçmiş deneyimler hakkında tipik mülakat soruları ve cevapları:',
          table: {
            headers: ['Mülakatçı', 'Aday'],
            rows: [
              ['Where did you work before?', 'I worked at a hotel for 2 years.'],
              ['What did you do there?', 'I served guests and handled complaints.'],
              ['Did you enjoy your job?', 'Yes, I did. I loved working with people.'],
              ['Why did you leave?', "I didn't leave. I want a career change."],
              ['What did you learn there?', 'I learned customer service and teamwork.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Geçmiş deneyimlerinizi anlatırken somut örnekler verin!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Deneyim Kelimeleri',
          words: [
            { en: 'previous', tr: 'önceki', pronunciation: '/ˈpriːviəs/' },
            { en: 'experience', tr: 'deneyim', pronunciation: '/ɪkˈspɪəriəns/' },
            { en: 'responsibility', tr: 'sorumluluk', pronunciation: '/rɪˌspɒnsəˈbɪləti/' },
            { en: 'achievement', tr: 'başarı', pronunciation: '/əˈtʃiːvmənt/' },
            { en: 'opportunity', tr: 'fırsat', pronunciation: '/ˌɒpəˈtjuːnəti/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillInBlank',
          sentence: 'Where _____ you work before?',
          answer: 'did',
          hint: 'Geçmiş zaman sorusu'
        },
        {
          type: 'fillInBlank',
          sentence: 'I _____ (work) at a restaurant for 3 years.',
          answer: 'worked',
          hint: 'Olumlu geçmiş zaman'
        },
        {
          type: 'multipleChoice',
          question: '"Why did you leave your last job?" - "I _____ leave, I want to try something new."',
          options: ["didn't", "don't", "wasn't", "haven't"],
          correct: "didn't",
          explanation: 'Geçmiş zaman olumsuz'
        },
        {
          type: 'speaking',
          instruction: 'Bu soruları cevaplayın:',
          phrases: [
            'Where did you work before?',
            'What did you do there?',
            'What did you learn?',
            'Why do you want this job?'
          ]
        }
      ]
    }
  },
  'A2-U2-EXAM': {
    id: 'A2-U2-EXAM',
    title: 'Ünite 2 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: "The flight _____ delayed.",
        options: ["wasn't", "weren't", "didn't", "don't"],
        correct: "wasn't",
        explanation: "The flight (tekil) ile wasn't"
      },
      {
        type: 'multipleChoice',
        question: "I _____ to the meeting yesterday.",
        options: ["didn't go", "didn't went", "not go", "wasn't go"],
        correct: "didn't go",
        explanation: "didn't + fiil kök hali"
      },
      {
        type: 'multipleChoice',
        question: '_____ you work last weekend?',
        options: ['Did', 'Do', 'Were', 'Was'],
        correct: 'Did',
        explanation: 'Geçmiş zaman sorusu: Did'
      },
      {
        type: 'multipleChoice',
        question: '_____ did you start working here?',
        options: ['When', 'What', 'Who', 'Which'],
        correct: 'When',
        explanation: 'When = Ne zaman'
      },
      {
        type: 'fillInBlank',
        sentence: "She _____ (not/check) the emergency equipment.",
        answer: "didn't check",
        hint: "didn't + fiil kök hali"
      },
      {
        type: 'fillInBlank',
        sentence: 'What _____ you do in your previous job?',
        answer: 'did',
        hint: 'WH + did + özne + fiil'
      },
      {
        type: 'matchPairs',
        instruction: 'Soruları cevaplarla eşleştirin',
        pairs: [
          { left: 'Did you work?', right: 'Yes, I did.' },
          { left: 'Was she late?', right: "No, she wasn't." },
          { left: 'Where did you go?', right: 'To the airport.' }
        ]
      }
    ]
  }
};

export default A2_UNIT_2;
